<template>
  <component
    :is="element"
    :class="['bigButton', classObj]"
    :to="to"
    v-on="$listeners"
  >
    <Spinner :class="['bigButton__spinner', { actived: busy }]" />
    <slot />
  </component>
</template>

<script>
import Spinner from '@/components/Spinner';

export default {
  name: 'BigButton',

  components: { Spinner },

  props: {
    to: {
      required: false,
      default: null,
      type: [String, Object],
    },
    secondary: {
      type: Boolean,
      default: false,
      required: false,
    },
    busy: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  computed: {
    element() {
      return this.to ? 'router-link' : 'button';
    },

    classObj() {
      const { secondary, busy } = this;

      return { secondary, busy };
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
